import React, { ReactNode } from 'react';
import { ButtonGroup, Button } from '@mui/material';

interface ButtonOptionPickerProps<OptionType> {
    selected: OptionType;
    setSelected: (o: OptionType) => void;
    options: [ReactNode, OptionType][];
}

export const ButtonOptionPicker = <OptionType, >({ options, selected, setSelected }: ButtonOptionPickerProps<OptionType>) => {
    return <ButtonGroup>
        {options.map(([label, option]) => (
            <Button
                size="small"
                color="primary"
                variant={selected === option ? 'contained' : 'outlined'}
                onClick={() => { if(selected !== option) { setSelected(option) }}}>
                {label}
            </Button>
        ))}
    </ButtonGroup>
}